import { matchPath, resolvePath, useLocation, useResolvedPath } from "react-router-dom";

import { Typography } from "../Typography";

import { useNavigationItems } from "./useNavigationItems";

/**
 *
 * Something like breadcrumbs
 */
export const AppLocation = () => {
  const location = useLocation();
  const resolvedPath = useResolvedPath("");
  const navigationItems = useNavigationItems();

  const activeItem = navigationItems.find((item) =>
    matchPath(resolvePath(item.to, resolvedPath.pathname).pathname, location.pathname),
  );

  return (
    <Typography as="div" uppercase fw="bold">
      {activeItem?.label}
    </Typography>
  );
};
